module.exports = __webpack_public_path__ + "static/media/step2.d26efafb.svg";